import { FORMS_DEFAULT_VALUE_SELECT } from "../constants/forms.constants"

export const changeValueSelect = (id, value) => ({
    type: FORMS_DEFAULT_VALUE_SELECT,
    id,
    value
})